<div class="mt-3">
  <kl-add-land-details
    [landDetails]="data?.data?.landDetails"
    [returnGeoTagDetails]="data?.data?.returnGeoTagDetails"
    [isAssisted]="data?.data?.isAssisted"
    (landAdded)="ok()"
    (geoTagDetails)="geoTagDetails($event)">
  </kl-add-land-details>
</div>
